import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putTimeType = (
    token: string,
    backend: string,
    changed_by_id: string,
    id: string,
    name: string,
    description: string,
    short_name: string,
    salary_code: string,
    tab_sequence: string,
    sales_price: string,
    cost_price: string,
    active: string,
    erp_product_id: string,
    
) => {
    return fetch(
        `${getApiUrl(backend)}timeTypes/${id}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                changed_by_id,
                name,
                description,
                short_name,
                salary_code,
                tab_sequence,
                sales_price,
                cost_price,
                active,
                erp_product_id,
            })
        }
    );
};

export default putTimeType